import React from 'react';
import { Button } from 'antd';
import styles from './index.module.less';

const CustomButton = ({
  children,
  className,
  font = 'bold',
  type = 'default',
  ...rest
}) => {
  return (
    <Button
      {...rest}
      type={type}
      className={`sfprotext-${font} ${
        type === 'secondary' ? styles.secondary_btn : ''
      } ${className} ${styles.btn_padding}`}
      style={{ fontSize: '13px' }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
